import { Panel } from '@/ui/atoms/panel/Panel'
import { Skeleton } from '@/ui/atoms/skeleton/Skeleton'
import { PageLayout } from '@/ui/layouts/PageLayout'
import { cn } from '@/ui/utils/style'

export function SwapSkeleton({ withHeading }: { withHeading?: boolean }) {
  return (
    <PageLayout className={cn(withHeading ? 'mt-8' : 'py-0')}>
      <div className="flex justify-center">
        <div className="w-full max-w-xl">
          {withHeading && <Skeleton className="mb-7 h-12 w-32" />}

          <Panel.Wrapper className={cn('w-full', withHeading ? 'mt-12' : '')}>
            <div className="p-6">
              <Skeleton className="mb-3 h-7 w-24" />
              <Skeleton className="mb-5 h-16 w-full" />
              <Skeleton className="mb-3 h-7 w-24" />
              <Skeleton className="mb-5 h-16 w-full" />
              <Skeleton className="mb-2 h-36 w-full" />
            </div>
          </Panel.Wrapper>
        </div>
      </div>
    </PageLayout>
  )
}
